import {useQuery} from "react-query";
import api from "../services/api";
import {useRecoilValue} from "recoil";
import {spaceIdState} from "../state/spaceState";
import queryClient from "../services/queryClient";

export const fetchValidateAuth = (timing) => {
  return api.post(`/timings/${timing}/valid`).then((response) => response?.data?.data.valid);
};

const useValidateAuth = () => {
  const id = useRecoilValue(spaceIdState);

  const query = useQuery(['valid', id], () => fetchValidateAuth(id), {
    enabled: !!id && !!queryClient.getQueryData(['valid', id]) !== undefined,
    staleTime: Infinity,
  });

  return query;
};

export default useValidateAuth;
